import { getDomain } from '@libs/utils';

import { trackHotjarEventWithLocaleRestriction } from './hotjarEvents';
import { HotjarEvent } from './hotjarEventsTypes';

export function triggerAccommodationHotjarSurvey(): void {
  const currentDomain = getDomain.getCurrentDomainSpec().Locale;

  if (currentDomain === 'sv') {
    trackHotjarEventWithLocaleRestriction(
      HotjarEvent.FindingAccommodationSurveySE,
      ['sv']
    );
  }
  if (currentDomain === 'dk') {
    trackHotjarEventWithLocaleRestriction(
      HotjarEvent.FindingAccommodationSurveyDK,
      ['dk']
    );
  }
  if (currentDomain === 'no') {
    trackHotjarEventWithLocaleRestriction(
      HotjarEvent.FindingAccommodationSurveyNO,
      ['no']
    );
  }
}
export function triggerFlightHotjarSurvey(): void {
  const currentDomain = getDomain.getCurrentDomainSpec().Locale;

  if (currentDomain === 'sv') {
    trackHotjarEventWithLocaleRestriction(HotjarEvent.FindingFlightsSurveySE, [
      'sv',
    ]);
  }
  if (currentDomain === 'dk') {
    trackHotjarEventWithLocaleRestriction(HotjarEvent.FindingFlightsSurveyDK, [
      'dk',
    ]);
  }
  if (currentDomain === 'no') {
    trackHotjarEventWithLocaleRestriction(HotjarEvent.FindingFlightsSurveyNO, [
      'no',
    ]);
  }
}
